import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import PreFooterNewsletter from "./PreFooterNewsletter";

export default function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1">{children}</main>
      <PreFooterNewsletter />
      <Footer />
    </div>
  );
}
